import { Box } from '@mui/material';
import { LwButton } from 'redesign';
import { IconApproved, IconCancel } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { useAddDocumentFormActions } from '../hooks/use-add-document-form-actions';

export const AddDocumentFormToolbox = () => {
  const { t } = useTranslation(['web-common', 'hq-screen-specific']);
  const { handleAddDocument, handleCancel, submitDisabled } = useAddDocumentFormActions();

  return (
    <>
      <Box>
        <LwButton
          type="submit"
          iconColorMode="stroke"
          color="primary"
          startIcon={<IconApproved />}
          onClick={handleAddDocument}
          disabled={submitDisabled}
        >
          {t('buttons.submit', { ns: 'web-common' })}
        </LwButton>
      </Box>
      <Box>
        <LwButton
          onClick={handleCancel}
          iconColorMode="fill"
          color="secondary"
          startIcon={<IconCancel />}
        >
          {t('buttons.cancel', { ns: 'web-common' })}
        </LwButton>
      </Box>
    </>
  );
};
